// One home for relationship-type colors. These mirror the --color-{type} custom
// properties in App.css; components previously kept private hardcoded copies.

export const RELATIONSHIP_TYPES = Object.freeze([
  "friend",
  "colleague",
  "alumni",
  "family",
  "acquaintance",
  "other",
]);

const FALLBACK = "#6B7280";

const HEX_BY_TYPE = Object.freeze({
  friend: "#2D6A4F",
  colleague: "#1C3F5E",
  alumni: "#92400E",
  family: "#6D28D9",
  acquaintance: "#4B5563",
  other: FALLBACK,
});

/** CSS value for a relationship type, preferring the custom property. */
export function relationshipColor(type) {
  const key = RELATIONSHIP_TYPES.includes(type) ? type : "other";
  return `var(--color-${key}, ${HEX_BY_TYPE[key]})`;
}

/** Raw hex, for canvas/SVG contexts that cannot resolve custom properties. */
export function relationshipHex(type) {
  return HEX_BY_TYPE[RELATIONSHIP_TYPES.includes(type) ? type : "other"] || FALLBACK;
}
